//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { productName } from "../../package.json";
export default {
  name: 'DevLayout',
  components: {
    FibAppStateInfo: require('@/components/AppStateInfo').default,
    FibSettings: require('@/pages/settings/Settings').default
  },
  data: function data() {
    return {
      leftDrawerOpen: false,
      productName: productName,
      showSettings: false,
      updateInProgress: false
    };
  },
  computed: {
    apiInProgress: get('settings/apiInProgress'),
    completedSurveyCount: get('responses/responsesTemp.length'),
    setupComplete: get('settings/setupComplete')
  }
};